export default __webpack_public_path__ + "static/media/sport.34f1801d.svg";